// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"
window.bootstrap = bootstrap

import "@fortawesome/fontawesome-free/js/all.js"

import "chartkick/chart.js"
import "./confirmation_modal"

import "./custom/responsibility_form"
import "./custom/add_project_researcher"
import "./custom/project_dates"
import "./custom/fundings_public_toggle"
import "./custom/year_input"
import "./custom/error_game"
import "./show_image_fadein"
import './homepage_counters'

// Import word cloud and make it globally available
import WordCloudRenderer from "./word_cloud"
window.WordCloudRenderer = WordCloudRenderer

import "trix"
import "@rails/actiontext"

// Initialize Bootstrap tooltips
document.addEventListener('turbo:load', () => {
  const tooltipTriggerList = document.querySelectorAll('[title]')
  const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl, {
    trigger: 'hover',
    container: 'body'
  }))
})
